import React, {useEffect, useState, useCallback} from 'react';
import {FormikErrors, useFormikContext} from 'formik';
import {useJobContext} from 'contexts/JobContext';
import {basename} from 'path';
import {FileUpload as FileUploadComponent} from 'shared/components/FileUpload/FileUpload';
import {useDeleteFileUploadMutation} from './store/jobApi';
import {PartialJob} from 'shared/types/PartialJob';

interface Form {
    files?: File[];
}
interface FileUploadProps {
    fileUploadErrors: FormikErrors<{[key: string]: Form}>;
    updateAttachmentsCount: (count: number) => void;
}

export const FileUpload = ({
    fileUploadErrors,
    updateAttachmentsCount,
}: FileUploadProps) => {
    const {setFieldValue} = useFormikContext<Form>();
    const [attachments, setAttachments] = useState<string[]>([]);
    const {job} = useJobContext() as PartialJob;
    const [deleteFile] = useDeleteFileUploadMutation();

    useEffect(() => {
        setAttachments(job?.attachments ?? []);
    }, [job?.attachments]);

    const deleteUploadedFile = useCallback(
        (index?: number) => {
            if (job?.attachments && index != undefined) {
                const file = job.attachments[Number(index)];
                const filename = basename(file);
                deleteFile({filename, jobId: job.id})
                    .then(() => {
                        attachments.splice(index, 1);
                        updateAttachmentsCount(attachments.length);
                        void setFieldValue('attachments', attachments);
                    })
                    .catch(() => {
                        // handle error
                    });
            }
        },
        [job, attachments]
    );

    return (
        <FileUploadComponent
            fileUploadErrors={fileUploadErrors}
            multiple={true}
            attachedFiles={attachments}
            deleteAttachedFileCallback={deleteUploadedFile}
            name="files"
        />
    );
};
